module.exports = __webpack_public_path__ + "static/media/logo_v_white.48622d96.png";